export const HuHeader = {
  "header": {
    "loggedRole": "Szerepkör: {role}",
    "loggedWith": "Belépve, mint {name}",
    "usedProject": "Projekt",
    "usedRoleView": "Felület"
  },
}